var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"tuanle",attrs:{"flat":""}},[_c('card-overview'),(false && _vm.promotion.type === 2)?_c('card-promotions-order',{staticClass:"mt-5"}):_vm._e(),_c('v-divider'),_c('card-slugs')],1)}
var staticRenderFns = []

export { render, staticRenderFns }